import React from 'react';

export const SvgGroupCenter: React.FC<{
  center?: boolean;
  baseWidth: number;
  baseHeight: number;
  children: React.ReactNode;
}> = (props) => {
  const translateHalf = `translate(-${props.baseWidth / 2}, -${
    props.baseHeight / 2
  })`;
  return <g transform={props.center ? translateHalf : ''}>{props.children}</g>;
};
